import React from 'react';
import useStyles from '../styles';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from 'components/common/Button';
import useSnack from 'hooks/useSnack';
import { useMutation } from '@apollo/react-hooks';
import { UPDATE_STUDENT_PROFILE } from 'graphql/student/Profile';
import extend from 'lodash/extend';
import { InputLabel } from '@material-ui/core';
import ToggleButton from '@material-ui/lab/ToggleButton';
import { Formik, Form, Field } from 'formik';
import { ToggleButtonGroup } from 'formik-material-ui-lab';
import options from 'constant/applicationQuestions';

const AppStatusForm = ({
  college_info,
  user,
  saveText,
  disableCard,
  isSkip,
  onSkip,
  step,
  history,
  onFinish,
  editable,
}) => {
  const classes = useStyles();
  const snack = useSnack();
  const [update] = useMutation(UPDATE_STUDENT_PROFILE);

  return (
    <Card className={classes.card} elevation={disableCard && 0}>
      <CardContent className={classes.cardContent}>
        <Box maxWidth={700} width="100%">
          <Typography gutterBottom variant="h5" align="center">
            Where are you in the college application process?
          </Typography>
          <Typography paragraph variant="caption" align="center">
            To help us customize WeAdmit for you, let us know your status for
            each stage of the college application process. Everyone moves at a
            different pace - please be as honest as possible so we know what you
            still need to work on!
          </Typography>
        </Box>
        <Box>
          <Formik
            initialValues={college_info}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                setSubmitting(false);
                values = { ...values, completed: true };
                return update({
                  variables: {
                    id: user.id,
                    input: {
                      application_progress: extend(college_info, values),
                    },
                  },
                }).then(
                  () => {
                    snack.success('Profile saved');
                    onFinish && onFinish();
                  },
                  (e) => {
                    snack.error(e.message);
                  },
                );
              }, 500);
            }}
          >
            {({ submitForm, isSubmitting, errors }) => (
              <Form>
                {options.map((op) => {
                  return (
                    <Grid
                      container
                      spacing={1}
                      style={{ marginBottom: 16 }}
                      alignItems="center"
                    >
                      <Grid item xs={12} md={5}>
                        <Typography variant="body1">{op.label}</Typography>
                      </Grid>
                      <Grid md={2}></Grid>
                      <Grid item xs={12} md={5}>
                        <Field
                          flex={2}
                          component={ToggleButtonGroup}
                          name={op.value}
                          type="checkbox"
                          exclusive
                          size="small"
                          className={classes.toggleBtnGroup}
                        >
                          <ToggleButton
                            disabled={!editable}
                            value="not_started"
                            aria-label="not started"
                          >
                            Not Started
                          </ToggleButton>
                          <ToggleButton
                            disabled={!editable}
                            value="working"
                            aria-label="working"
                          >
                            Working on it
                          </ToggleButton>
                          <ToggleButton
                            disabled={!editable}
                            value="done"
                            aria-label="done"
                          >
                            Done!
                          </ToggleButton>
                        </Field>
                      </Grid>
                    </Grid>
                  );
                })}

                {!disableCard && <Divider />}
                <CardContent className={classes.footer}>
                  <Box display="flex" justifyContent="center">
                    {isSkip && (
                      <div style={{ marginRight: 24 }}>
                        <Button
                          size="large"
                          onClick={onSkip}
                          variant="outlined"
                        >
                          Skip
                        </Button>
                      </div>
                    )}
                    <Button
                      size="large"
                      variant="contained"
                      color="primary"
                      disabled={isSubmitting}
                      onClick={submitForm}
                      disabled={!editable}
                    >
                      {saveText || 'Save'}
                    </Button>
                  </Box>
                </CardContent>
              </Form>
            )}
          </Formik>
        </Box>
      </CardContent>
    </Card>
  );
};

export default AppStatusForm;
